import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * TS 5.7+'s DOM lib types Uint8Array.buffer as ArrayBufferLike (including
 * SharedArrayBuffer), which Blob's constructor no longer accepts directly even
 * though every Uint8Array we produce in this app is backed by a plain ArrayBuffer.
 * Centralizing the cast here instead of scattering `as ArrayBuffer` everywhere.
 */
export function bytesToBlob(bytes: Uint8Array, type?: string): Blob {
  const buffer = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength) as ArrayBuffer;
  return new Blob([buffer], type ? { type } : undefined);
}

export async function blobToBytes(blob: Blob): Promise<Uint8Array> {
  return new Uint8Array(await blob.arrayBuffer());
}
